// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1p8ee","emails":"CreateEditClinics_emails__zO6q_","emailTagLabel":"CreateEditClinics_emailTagLabel__1PYpH"};